import { IVariable } from 'api/digifi/VariablesApi';
import createEntitiesLoader from 'providers/createEntitiesLoaderProvider';
import { recomputeUnknownVariablesFor, saveVariables } from 'handlers/variablesSlice';
import { IReduxState } from 'types/ReduxState';
import { variablesApi } from 'store/api';

const [
  VariablesBySystemNameLoaderContext,
  VariablesBySystemNameLoader,
] = createEntitiesLoader<IVariable, string>({
  isEntityLoaded: (field: string, state: IReduxState) => !!state.variables.variablesBySystemName[field],
  searchEntities: async (systemNames: string[]) => {
    const { items } = await variablesApi.search({
      systemNames,
      showArchived: true,
    });

    return items;
  },
  createRecomputeUnknownEntitiesForAction: recomputeUnknownVariablesFor,
  createSaveEntitiesAction: saveVariables,
});

export {
  VariablesBySystemNameLoaderContext,
  VariablesBySystemNameLoader,
};
